import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { IPermissionProps } from "../../models/Login";
import { IRemitance } from "../../models/Remitance";
import { Table } from "./Table";
import { EmptyRemitance } from "./EmptyRemitance";
import { Form } from "./Form";

export interface IModel {
    open: boolean,
    singleData: IRemitance
}

export const Remitance = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyRemitance, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyRemitance, open: false })
    };


    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
